import { Permission, alphabeticalSort, notEqual } from '@cims-online/shared'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  RoutingGroup,
  useRoutingGroupsTableContext,
} from '../../../../RoutingGroupsTableContext'
import { useEditCasRoutingGroupMutation } from 'schema'
import { useUserSelectContext } from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import { CreateEditFormItems } from '../../components/CreateEditFormItems'
import { CreateEditFormItemsValues } from '../../components/CreateEditFormItems/types'

export function useEditOptions(): EditRowActionOptions<
  RoutingGroup,
  CreateEditFormItemsValues
> {
  const { refetch } = useRoutingGroupsTableContext()
  const { toLabeledValues, fromLabeledValues } = useUserSelectContext()
  const [editRoutingGroup] = useEditCasRoutingGroupMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editCASRoutingGroup: {
        routingGroup: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditCASRoutingGroup,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <CreateEditFormItems />,
      initialValues: ({ name, users, description }) => {
        return {
          name,
          description,
          users: toLabeledValues(users).sort(alphabeticalSort('label')),
        }
      },
      onOk: async ({ id, ...routingGroup }, { name, users, description }) => {
        const prevUserIds = routingGroup.users.map(({ id }) => id)
        const userIds = fromLabeledValues(users)
        if (
          routingGroup.name !== name ||
          notEqual(prevUserIds, userIds) ||
          routingGroup.description !== description
        ) {
          await editRoutingGroup({
            variables: {
              editCASRoutingGroupInput: {
                id,
                name,
                userIds,
                description,
              },
            },
          })
          await refetch()
        }
      },
    },
  }
}
